<script setup lang="ts">
import { CircleUserIcon } from 'lucide-vue-next'

const account = useAccountStore()
</script>

<template>
  <div :class="$attrs.class">
    <div class="space-y-4 h-full overflow-y-auto py-2">
      <div class="px-0 pt-0 h-full">
        <div class="space-y-1 flex flex-col h-full">
          <SideMenu class="h-full overflow-y-auto"></SideMenu>
          <UserMenu label="@Forwarder">
            <template #trigger="{ on }">
              <DBtn
                text
                plain
                class="w-full justify-start py-2 rounded-none border-none focus:ring-0"
                size="small"
                v-on="on"
              >
                <CircleUserIcon class="ml-2 mr-1 h-4 w-4 shrink-0" />
                <span class="truncate">
                  {{ account.user?.fullName || account.user?.email }}
                </span>
              </DBtn>
            </template>
          </UserMenu>
        </div>
      </div>
    </div>
  </div>
</template>
